var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorPageAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 401,
    height: 301,
    viewBox: "0 0 401 301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFCFC",
    d: "M111.905 290.216S21.322 275.123 1.89 200.974c-7.064-26.958 6.147-55.274 31.665-66.479 16.05-7.049 39.42-11.676 73.439-10.166 0 0 80.71 9.58 94.99-51.709 4.896-21.01 15.52-36.857 29.227-48.158 32.928-27.147 79.138-32.454 116.658-12.119C367.386 22.921 383.15 41.57 391.344 72c23.594 87.615-1.861 160.802-53.784 195.57-43.26 28.969-108.99 44.05-225.655 22.647"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#92C3FE",
    d: "M48.991 219.995l-12.385-108.5h-6.7l6.211 46.789H22.151l6.213-46.789h-6.7l-12.387 108.5c-.156 1.376.92 2.581 2.305 2.581 1.163 0 2.146-.86 2.3-2.013l7.605-57.278H36.78l7.606 57.278c.154 1.152 1.136 2.013 2.3 2.013 1.385 0 2.461-1.205 2.304-2.581M196.672 219.995l-12.387-108.5h-6.7l6.213 46.789H169.83l6.213-46.789h-6.7l-12.387 108.5c-.157 1.376.92 2.581 2.305 2.581 1.163 0 2.147-.86 2.299-2.013l7.606-57.278h15.295l7.606 57.278c.152 1.152 1.136 2.013 2.3 2.013 1.384 0 2.46-1.205 2.304-2.581",
    transform: "matrix(-1 0 0 1 393 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDF",
    d: "M15.972 113.481L15.972 103.593 199.672 103.593 199.672 114.188 15.972 113.481",
    transform: "matrix(-1 0 0 1 393 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0EDFC",
    d: "M0 107.151L212.49 107.151 212.49 100.036 0 100.036z",
    transform: "matrix(-1 0 0 1 393 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5E7FF",
    d: "M94.533 77.632l-9.224 17.096c-1.293 2.396.442 5.308 3.168 5.308h54.406l-22.717-12.193 4.585-10.211H94.533",
    transform: "matrix(-1 0 0 1 393 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3D2FA",
    d: "M167.074 68.54l-6.932-61.492C159.688 3.034 156.293 0 152.254 0H56.885c-4.26 0-7.632 3.608-7.34 7.86l4.341 63.557c.239 3.499 3.147 6.215 6.654 6.215h98.411c4.877 0 8.67-4.245 8.123-9.092",
    transform: "matrix(-1 0 0 1 393 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5E7FF",
    d: "M167.074 68.54l-6.932-61.492C159.688 3.034 156.293 0 152.254 0H62.251c-4.796 0-8.583 4.072-8.236 8.856l4.374 60.342c.344 4.754 4.3 8.434 9.067 8.434h91.495c4.877 0 8.67-4.245 8.123-9.092",
    transform: "matrix(-1 0 0 1 393 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7373",
    d: "M62.025 9.62l4.652 59.067c.037.464.426.823.891.823h91.76c.529 0 .941-.458.887-.985l-6.068-59.068c-.048-.455-.43-.801-.89-.801H62.916c-.52 0-.93.443-.89.963",
    transform: "matrix(-1 0 0 1 393 32)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.473 20.91l-13.631.087c-2.03.084-3.746-1.488-3.831-3.513L.003 3.911C-.08 1.886 1.495.174 3.525.09L17.158.002c2.03-.084 3.745 1.49 3.83 3.513l1.009 13.575c.084 2.025-1.493 3.735-3.524 3.819",
    transform: "matrix(-1 0 0 1 393 32) translate(100.423 40.456)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7373",
    d: "M16.159 18.513L3.487 5.84c-.65-.65-.65-1.704 0-2.353.65-.65 1.704-.65 2.354 0L18.513 16.16c.65.65.65 1.703 0 2.353-.65.65-1.704.65-2.354 0",
    transform: "matrix(-1 0 0 1 393 32) translate(100.423 40.456)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7373",
    d: "M3.48 16.202L16.202 3.48c.64-.64 1.679-.64 2.318 0 .64.64.64 1.679 0 2.318L5.798 18.52c-.64.64-1.678.64-2.318 0-.64-.64-.64-1.677 0-2.318",
    transform: "matrix(-1 0 0 1 393 32) translate(100.423 40.456)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F89B77",
    d: "M65.767 118.238c-.199-.818-.095-2.083 2.463-3.515 2.561-1.431 8.269-5.556 10.23-5.666 1.96-.114 4.942.62 5.735.6.796-.018 2.325 5.261 2.325 5.261l-20.753 3.32",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#388AFC",
    d: "M134.097 66.193L116.993 99.787 81.901 108.802 85.299 117.684 123.015 115.006 141.519 84.197 134.097 66.193",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333330",
    d: "M30.15 202.542s-7.848 3.3-11.356 4.446c-3.505 1.146-16.342-.141-17.768.884-1.425 1.03-1.485 4.909.58 5.588 2.063.68 17.396 4.207 22.745 3.704 5.345-.504 14.753 2.86 17 2.422 2.246-.434 2.441-12.189 1.966-14.9-.472-2.71-13.168-2.144-13.168-2.144",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDAA8A",
    d: "M31.955 197.832l-1.806 4.71s9.458 3.144 13.168 2.143l1.24-4.801-12.602-2.052",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424240",
    d: "M51.306 206.733s-7.404 4.207-10.748 5.761c-3.345 1.552-16.245 1.794-17.538 2.98-1.297 1.19-.894 5.05 1.233 5.481 2.13.431 17.774 2.114 23.025.982 5.249-1.133 14.99 1.092 17.167.393 2.177-.698.982-12.394.189-15.027-.79-2.634-13.328-.57-13.328-.57",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDAA8A",
    d: "M52.41 201.838l-1.104 4.895s9.763 2.001 13.328.57l.664-4.918-12.888-.547",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001C68",
    d: "M126.6 113.688s-33.752.277-37.89.821c-4.483.592-21.446.768-23.566 3.766-21.402 30.278-35.97 80.205-35.97 80.205l16.915 3.106s16.358-29.551 23.208-44.902c6.154-13.782 11.418-17.324 24.337-17.022 12.92.305 54.235-2.348 78.056-5.1l-45.09-20.874",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFBEB6",
    d: "M119.303 44.653s-3.31 14.524-2.502 22.528c.812 8.005 13.59 28.075 14.197 32.534.607 4.461-2.889 13.674-2.889 13.674l44.233 20.477s-.076-12.81-1.891-28.01c-1.82-15.196-7.546-27.225-9.55-35.815-6.84-29.309-31.863-33.383-31.863-33.383l-9.735 7.995",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003180",
    d: "M128.257 112.99s-34.758.276-38.895.824c-4.487.591-22.444.875-24.168 4.119-12.262 23.085-15.018 84.704-15.018 84.704l15.78 1.777s7.749-31.272 10.181-46.167c2.432-14.895 5.472-17.06 18.39-16.757 12.92.305 63.52 13.778 77.815-7.624l-44.085-20.876",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDAA8A",
    d: "M85.853 21.31s.412 8.904 2.838 8.87c2.005-.029 2.744 8.51 2.97 9.841.227 1.334 3.81.249 4.887.545 1.08.295 8.171 7.661 10.89 6.377 2.718-1.283 11.858-12.242 13.041-17.402 1.18-5.16-5.113-21.487-10.955-26.458-5.846-4.972-24.325 2.63-23.67 18.227",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6AB8F",
    d: "M111.893 39.833s.415.714 1.041 1.83c.463.822 1.035 1.857 1.64 2.99 1.636 3.061 3.492 6.802 3.907 8.71.778 3.567 8.898-16.444 8.898-16.444s-5.874-10.229-10.543-22.566c-4.666-12.337-4.943 25.48-4.943 25.48",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#001C68",
    d: "M86.004 23.2s-8.067-5.04-4.575-14.47c3.49-9.43 21.575-7.422 23.19-7.9 1.613-.478 9.756-4.666 14.234 11.635 4.477 16.302 3.042 13.999 3.042 13.999s-5.421-5.677-8.294-4.752c-3.115 1.007-8.004 3.103-8.004 3.103s-1.41-7.725-5.654-6.39c-4.245 1.337-11.022 1.129-13.939 4.776",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEA886",
    d: "M107.38 18.834c-.191-1.06-1.365-5.41 3.135-5.142 4.496.265 3.527 10.374 3.027 10.799-.5.424-4.544 3.269-6.161-5.657",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A77860",
    d: "M112.934 41.664c.463.821 1.035 1.856 1.64 2.989 3.124-5.594 4.924-11.63 5.44-13.501-1.117 3.215-7.08 10.512-7.08 10.512",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C98462",
    d: "M109.923 42.903s.057-2.963.183-3.873c.122-.91-1.803-.296-2.159.762-.358 1.057 1.976 3.111 1.976 3.111",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F89B77",
    d: "M95.742 41.283s-.305 1.296-.16 1.929c0 0 .35 1.13.55 1.947.063.262.11.488.126.64.07.628.029 2.029.617 3.492.582 1.463 3.559 7.825 3.559 7.825l4.184-1.237 3.292-1.114s2.589-10.046 2.202-11.471c-.038-.139-.082-.277-.132-.4-.447-1.177-1.271-1.863-1.576-2.454-.114-.217-1.382-2.29-2.1-2.395-.997-.141-1.749.164-2.205.68 0 0-1.966-.198-3.074.541 0 0-1.809-.242-2.923 1.07 0 0-1.862-.038-2.36.947",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDDAD3",
    d: "M126.48 35.292s-5.116 11.925-9.487 15.968l2.061 7.095 9.984-21.697-2.558-1.366",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M128.257 112.99s.636-1.706 1.12-3.38c.485-1.674 13.6 5.233 13.6 5.233l-3.154 3.65-11.566-5.503",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#579DFF",
    d: "M120.624 72.624c1.25 2.562 2.439 5.16 3.571 7.775v.003c2.492 5.755 4.707 11.607 6.661 17.33.696 2.043 1.36 4.069 1.992 6.07 7.532 23.84 10.528 44.056 10.528 44.056s28.163-7.495 32.37-11.208c0 0-6.866-99.744-46.708-99.992-.249.374-14.98 22.531-8.414 35.966",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E71E5",
    d: "M130.856 97.733c.696 2.042 1.36 4.068 1.992 6.069 6.201-9.81 17.135-33.393 17.305-33.76l-19.297 27.69",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#579DFF",
    d: "M109.36 53.076l-10.682 3.546 9.858 51.922c1.098 4.92 7.306 6.535 10.663 2.768 9.203-10.317 23.79-27.527 30.17-39.679 9.679-18.438-6.475-24.853-10.351-20.21-3.876 4.645-20.99 35.964-20.99 35.964l-8.668-34.311",
    transform: "matrix(-1 0 0 1 253 57)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424240",
    d: "M190.355 27.996l-16.547 48.53c-.126.371-.202.755-.227 1.142l-3.967 63.815-69.193 1.542-20.159 73.39c-.61 2.221-.22 4.603 1.114 6.494.878 1.246 2.133 2.344 3.886 2.558 4.386.538 93.212 0 93.212 0v-3.669c0-1.83-1.514-3.313-3.38-3.313H92.053c-1.369 0-2.684-.594-3.527-1.655-.491-.623-.844-1.394-.705-2.272.365-2.337 18.095-62.135 18.095-62.135l66.902-1.186c3.045-.053 5.522-2.423 5.647-5.405l2.908-68.661c.019-.437.088-.868.21-1.29l13.527-46.397s1.416-3.234-1.19-3.546c-2.605-.315-3.275 1.211-3.564 2.058",
    transform: "matrix(-1 0 0 1 253 57)"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Geist, sans-serif",
    fontSize: 19,
    fontStyle: "italic",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 258.259,
    y: 63
  }, "\n        Error\n      ")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPageAsset);
export default __webpack_public_path__ + "static/media/error-page-asset.457a3d43dfde3f2ed6a50c3c3485029e.svg";
export { ForwardRef as ReactComponent };